import type { CSSProperties } from 'react'

import { ApprovalMode } from '@ebalance/proto/bfftypes/v1/approval_flow_type_pb'
import type { useTranslation } from 'react-i18next'

import { fontSizes } from '@enechain/ecloud-designsystem'

import type { DsSelectOptions } from '~/components/common/DsSelect'
import { eclColor } from '~/pages/AdminApprovalFlow/constants/eclColor'

/** セレクトの 1 選択肢 (mode 値 + 表示ラベル)。 */
export type ModeOption = { value: ApprovalMode; label: string }

/** セルの 4値セレクト用選択肢 (未設定 / 要承認 / 自動 / 承認なし)。 */
export function getModeOptions(
  t: ReturnType<typeof useTranslation>['t'],
): ModeOption[] {
  return [
    {
      value: ApprovalMode.UNSPECIFIED,
      label: t('page:adminApprovalFlow.mode.unset'),
    },
    {
      value: ApprovalMode.APPROVAL,
      label: t('page:adminApprovalFlow.mode.approval'),
    },
    { value: ApprovalMode.AUTO, label: t('page:adminApprovalFlow.mode.auto') },
    {
      value: ApprovalMode.NO_APPROVAL,
      label: t('page:adminApprovalFlow.mode.noApproval'),
    },
  ]
}

/**
 * `ModeOption[]` (proto enum = number) を DS `Select` の選択肢 (value は string) へ変換する。
 */
export function toDsSelectOptions(options: ModeOption[]): DsSelectOptions {
  return options.map((o) => ({ value: String(o.value), label: o.label }))
}

/**
 * 「保存」を押した後に、 保存を止めているセルを直す入口へ付ける属性 (AC-APF-071)。
 * `MatrixModeCell` の td と、 マトリクスを畳んでいる時の一括編集ボタンに付け、
 * `ProcessAccordion` が最初の 1 つへスクロールしてフォーカスする。
 */
export const SAVE_ERROR_ATTR = 'data-save-error'

/** テーブルヘッダ背景 (eclair Surface.tableHeader)。 */
export const TABLE_HEADER_BG = eclColor.surfaceTableHeader

/** マトリクス本体の `<table>` style。 */
export const matrixTableStyle: CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: fontSizes.sm.value,
}
